const gu = {
  brand: {
    name: "ગુજરાત ફાર્મા યુનિયન",
    short: "GPU",
    motto: "એકતા • અનુપાલન • સુરક્ષા",
    positioning: "અસલ દવાઓ • ન્યાયી વ્યાપાર • મજબૂત ફાર્મા સમુદાય",
  },
  nav: {
    home: "હોમ",
    about: "અમારા વિશે",
    aboutGpu: "GPU વિશે",
    objectives: "અમારા ઉદ્દેશ",
    committees: "નેતૃત્વ અને સમિતિઓ",
    districts: "જિલ્લા શાખાઓ",
    institutional: "સંસ્થાકીય જોડાણ",
    ethics: "નૈતિક આચારસંહિતા",
    membership: "સભ્યપદ",
    memberBenefits: "સભ્ય લાભ",
    memberRegistration: "સભ્ય કેવી રીતે બનવું",
    declaration: "સભ્યપદ ઘોષણા",
    vendors: "વેન્ડર",
    vendorNetwork: "વેન્ડર નેટવર્ક",
    vendorRegistration: "વેન્ડર નોંધણી",
    protection: "સુરક્ષા",
    gpuProtection: "GPU સુરક્ષા",
    safeTrade: "સેફ ટ્રેડ નેટવર્ક",
    antiCounterfeit: "નકલી વિરોધી",
    resources: "સંસાધનો",
    knowledge: "નોલેજ સેન્ટર",
    downloads: "ડાઉનલોડ સેન્ટર",
    faq: "પ્રશ્નોત્તરી",
    news: "સમાચાર અને અપડેટ",
    events: "કાર્યક્રમો",
    media: "મીડિયા",
    verify: "GPU ID ચકાસો",
    contact: "સંપર્ક",
    menu: "મેનૂ",
    close: "બંધ કરો",
  },
  cta: {
    joinMember: "સભ્ય તરીકે જોડાઓ",
    registerVendor: "વેન્ડર તરીકે નોંધણી",
    memberLogin: "સભ્ય લોગિન",
    vendorLogin: "વેન્ડર લોગિન",
    joinGpu: "GPU માં જોડાઓ",
    knowMore: "વધુ જાણો",
    startMemberRegistration: "સભ્ય નોંધણી શરૂ કરો",
    startApplication: "અરજી શરૂ કરો",
    applyAsVendor: "વેન્ડર તરીકે અરજી કરો",
    exploreProtection: "GPU સુરક્ષા જાણો",
    learnSafeTrade: "સેફ ટ્રેડ વિશે જાણો",
    viewAllCommittees: "બધી સમિતિઓ જુઓ",
    verifyMember: "GPU સભ્ય ચકાસો",
    verifyVendor: "GPU વેન્ડર ચકાસો",
    becomeMember: "સભ્ય બનો",
    memberLoginForSupport: "સહાય માટે સભ્ય લોગિન",
    openApp: "GPU એપ ખોલો",
    getApp: "GPU એપ મેળવો",
    viewAll: "બધું જુઓ",
    readMore: "વધુ વાંચો",
    back: "હોમ પર પાછા",
  },
  common: {
    comingSoon: "ટૂંક સમયમાં",
    important: "મહત્વપૂર્ણ",
    disclaimer: "અસ્વીકરણ",
    language: "ભાષા",
    english: "English",
    gujarati: "ગુજરાતી",
    noContentYet: "આ વિભાગ GPU સચિવાલય દ્વારા સંચાલિત છે. અધિકૃત પ્રકાશન પછી સામગ્રી દેખાશે.",
    searchPlaceholder: "સંસાધનો, પરિપત્રો, પ્રશ્નો શોધો…",
    loading: "લોડ થઈ રહ્યું છે…",
    appNote: "નોંધણી અને લોગિન અધિકૃત GPU મોબાઇલ એપ્લિકેશન અને સભ્ય પોર્ટલમાં થાય છે.",
  },
  home: {
    hero: {
      eyebrow: "ગુજરાત ફાર્મા યુનિયન",
      line1: "સુરક્ષિત અને મજબૂત",
      line2: "ફાર્મા વ્યાપાર માટે",
      line3: "એકજૂટ",
      sub: "ગુજરાત ફાર્મા યુનિયન લાઇસન્સ ધારક ફાર્માસ્યુટિકલ વેપારીઓને એક વિશ્વસનીય પ્લેટફોર્મ પર લાવે છે — અનુપાલન, અસલ દવાઓ, ન્યાયી વ્યાપાર અને સામૂહિક સુરક્ષા પર કેન્દ્રિત.",
      scroll: "નીચે સ્ક્રોલ કરો",
    },
    counters: {
      title: "સંસ્થા એક દૃષ્ટિએ",
      note: "આંકડા GPU સચિવાલય દ્વારા સંચાલિત છે. અધિકૃત ચકાસણી પછી વાસ્તવિક આંકડા પ્રકાશિત થશે.",
      members: "ચકાસાયેલ સભ્યો",
      vendors: "ચકાસાયેલ વેન્ડર",
      districts: "આવરી લેવાયેલા જિલ્લા",
      committee: "સમિતિ સભ્યો",
      support: "નિવારેલ સહાય વિનંતીઓ",
    },
    why: { eyebrow: "GPU શા માટે", title: "ગુજરાત ફાર્મા યુનિયન શા માટે?" },
    principle: {
      eyebrow: "અમારો સિદ્ધાંત",
      title: "દર્દીનું રક્ષણ કરો. વાસ્તવિક દોષિતને ઓળખો. અસલ ફાર્માસ્યુટિકલ સપ્લાય ચેઇનનું રક્ષણ કરો.",
    },
    finalCta: {
      title: "એક મજબૂત ફાર્માસ્યુટિકલ સમુદાયમાં જોડાઓ",
      sub: "વિશ્વાસ બનાવો. અનુપાલન રાખો. જવાબદારીથી વ્યાપાર કરો. એકજૂટ રહો.",
    },
  },
};

export default gu;
